<ng-container *ngIf="!property.config.allowedValues?.length; else enum">
  <!-- Blur before native wheel stepping without cancelling scrolling or Ctrl+wheel zoom. -->
  <input
    *ngIf="property.config.format !== 'currency'; else currencyTemplate"
    #numberInput
    type="number"
    [required]="required"
    [formControl]="control"
    [min]="property.config.min ?? null"
    [max]="property.config.max ?? null"
    [step]="property.config.step ?? 1"
    (wheel)="$event.ctrlKey ? null : numberInput.blur()"
    (blur)="markAsTouched()"
    [placeholder]="'Please enter ' + property.name + '...'"
  />

  <ng-template #currencyTemplate>
    <div class="flex flex-row w-full h-full gap-2 justify-center align-middle items-center">
      <span>$</span>
      <input
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        inputmode="decimal"
        [allowNegativeNumbers]="true"
        [required]="required"
        [formControl]="control"
        (blur)="markAsTouched()"
      />
    </div>
  </ng-template>
</ng-container>

<span class="text-danger" slot="hint" *ngIf="showErrors && control.touched && control.hasError('required')">
  {{ property.name }} must have a value
</span>

<span class="text-danger" slot="hint" *ngIf="showErrors && control.touched && control.hasError('min')">
  {{ property.name }} must be {{ formatValue(property.config.min) }} or greater
</span>

<span class="text-danger" slot="hint" *ngIf="showErrors && control.touched && control.hasError('max')">
  {{ property.name }} must be {{ formatValue(property.config.max) }} or less
</span>

<span class="text-danger" slot="hint" *ngIf="showErrors && control.touched && control.hasError('step')">
  {{ property.name }} must use increments of {{ formatValue(property.config.step) }} starting from
  {{ formatValue(property.config.min ?? 0) }}
</span>

<span class="text-danger" slot="hint" *ngIf="showErrors && control.touched && control.hasError('number')">
  {{ property.name }} must be a valid number
</span>

<span class="text-danger" slot="hint" *ngIf="showErrors && control.touched && control.hasError('allowedValues')">
  {{ property.name }} must be one of {{ allowedValueLabels }}
</span>

<ng-template #enum>
  <vs-select class="!w-full pt-[6px]" [formControl]="control" (valueChanges)="markAsTouched()">
    <li vs-select-option *ngFor="let option of property.config.allowedValues" [value]="option">
      {{ formatValue(option) }}
    </li>
  </vs-select>
</ng-template>
